export enum TaxType {
  PIS_COFINS = 'pisCofins',
  ICMS = 'icms',
}
